'use strict';

var _ = require('lodash');
var d3 = require('d3');
var ChartSponsorForecastFlightScales = function ChartSponsorForecastFlightScales(momentService) {
  var Scales = function Scales(params, data, xRange, yRange) {
    if (!yRange) {
      var currentTime = momentService.now(momentService.FIELD.DEPARTURE_DATE).startOf('day');
      var yMin = currentTime;
      var yMax = currentTime.add(1, 'days');
      yRange = [yMin, yMax];
    }

    // the brush can modify the visible xRange of elements
    data = data.slice(xRange[0], xRange[1]);
    var x = d3.scale.ordinal().domain(_.map(data, 'date')).rangeBands([0, params.width], 0.1, 0.05);
    var y = d3.time.scale.utc().range([params.height, 0]).domain(yRange);
    return {
      xScale: x,
      yScale: y
    };
  };
  return Scales;
};
ChartSponsorForecastFlightScales.$inject = ['MomentService'];
module.exports = ChartSponsorForecastFlightScales;